import { initialLoad } from './src/browser';

export {
  onInitialClientRender,
  onPreRouteUpdate,
  onRouteUpdate,
  wrapPageElement,
} from './src/browser';

initialLoad();
